import Vue from 'vue'
import Vuex from 'vuex'
import lead from './../data/lead'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

let leadToUse = lead

let cart = truecart.length ? truecart : []

if (leadPreloaded) {
    leadToUse = {...leadToUse, ...leadPreloaded}
}

const store = new Vuex.Store({
    state: {
        user: {},
        headerNumber: '(888) 328-3124',
        headerNumberLink: 'tel:+18883283124',
        supportNumber: '(888) 328-3124',
        supportNumberLink: 'tel:+18883283124',
        consentToCall: false,
        isBusinessHours: false,
        talkWithGuideVisible: false,
        previousRoute: '',
        errors: {},
        lead: leadToUse,
        questions: [],
        newUser: true,
        uuid: null,
        cart,
        system: {
            essential: [],
            additional: [],
            adviceUnresolved: {},
            advice: {},
            total: 0,
            discountedTotal: 0,
            totalFormatted: '',
            discountedTotalFormatted: '',
            monthly: 0,
            savings: 0,
            monitoringPlans: [],
            monitoringPlanFrequency: '',
            paymentMethod: '',
            monitoringPaymentMethod: ''
        },
        order: {
            uuid: ''
        },
        adviceCount: 0,
        availableAreas: [],
        advice: {
            intrusion: [],
            environmental: [],
            automation: []
        },
        environmentalRecommendations: {
            Fire: 0,
            CarbonMonoxide: 0,
            Flooding: 0,
            LowTemperature: 0
        },
        areaOfConcernSectionIndex: -1,
        areaOfConcern: {
            id: '',
            name: '',
            editing: false,
            accessibleFromGroundFloor: null,
            accessOverride: false,
            analyzed: false,
            windows: 0,
            windowsInput: null,
            windowsThatOpen: 0,
            windowsThatOpenInput: null,
            expanded: false,
            glassBreakRecommended: false,
            equipmentOptionChosen: null,
            equipmentOptions: [],
            image: null,
            interestedInMotion: false
        },
        emptyAreaOfConcern: {},
        currentAreaOfConcernIndex: null,
        monitoringPlans: [],
        guarantees: [
            {
                title: 'ADT Money Back Guarantee',
                description:
                    'The strongest guarantee in the industry. If we are unable to provide a solution to any problem within six months of installation, we will refund the system installion price and pay all monitoring fees.',
                link: '',
                expanded: false
            },
            {
                title: "Homeowner's Insurance Certificate",
                description:
                    "Feel safe and save money! Having ADT monitored security service may help you save on your homeowner's insurance.",
                link: '',
                expanded: false
            },
            {
                title: 'Theft Protection Guarantee',
                description:
                    'You can feel confident using the ADT home security system knowing we stand behind our product and service. In the event a burglary occurs while the system is armed,* we will pay up to $500 of your insurance deductible.',
                link: '',
                expanded: false
            }
        ],
        automationInterestsMore: {
            FrontDoorCamera: false,
            InteriorCameras: false,
            RemoteDoorLocks: false,
            SmartThermostat: false,
            LightingControl: false,
            Fire: false,
            CarbonMonoxide: false,
            Flooding: false,
            LowTemperature: false
        },
        automationInterestsToRemove: {
            FrontDoorCamera: false,
            InteriorCameras: false,
            RemoteDoorLocks: false,
            SmartThermostat: false,
            LightingControl: false,
            Fire: false,
            CarbonMonoxide: false,
            Flooding: false,
            LowTemperature: false
        },
        headerShadow: false,
        equipment: [],
        editHomeVisible: false,
        monitoringFrequencyVisible: false,

        slideout: {
            open: false
        }
    },
    getters,
    mutations,
    actions
})

export default store
